module.exports = __webpack_public_path__ + "static/media/section10-illustration.44ff2e18.png";